import { create } from '@wix/fedops-logger';

import { ROUTES } from '../constants';

export const createFedopsLogger = (isWidget: boolean) => {
  return create('wix-chatbot-client', {
    customParams: {
      path: isWidget ? ROUTES.WIDGET : ROUTES.MAIN,
    },
  });
};
